module.exports = __webpack_public_path__ + "img/palmar-room-14.154c48a0.jpg";